import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { message } from "antd";
import Profile from "assets/img/default-avatar.png";
import AllFreelancer from "./AllFreelancers";
import FeaturedFreelancerr from "./FeaturedFreelancer";
import { BsArrowLeftShort } from "react-icons/bs"
import "assets/css/demo.css"

import MyContext from "MyContext";
import {
  useTable,
  usePagination,
  useGlobalFilter,
  useSortBy,
} from "react-table";

import ReactPaginate from 'react-paginate';
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Form
} from "react-bootstrap";
import AddFreelancer from "./Userform";
import UploadCSVfile from "./UploadCSVfile";
import { data } from "jquery";



function Freelancer() {
  const { endPointUrl, Token } = useContext(MyContext);
  const [items, setitems] = useState({});
  const [updateFreelancer, setUpdateFreelancer] = useState([]);
  const [showall, setShowall] = useState(true);
  const [showfeaturedFreelancer, setShowfeaturedFreelancer] = useState(false);
  const [activeCard, setActiveCard] = useState("all");
  const [showAdd, setshowAdd] = useState(false);
  const [showmodel, setshowModel] = useState(false);

  const count = async () => {
    try {
      const { data } = await axios.post(endPointUrl + "/admin/counts", {
        Token,
      });
      setitems(data.data);
      //  console.log(data.data.publishedjobCount);



    } catch {
      console.log("counts is not working");
    }
  };

  useEffect(() => {
    count();
  }, [updateFreelancer]);

  const handlecount = () => {
    count();
  }

  const navigateToall = () => {
    // history.push("/admin/Published-Jobs"); 
    setShowall(true); // Set showPublishedJobs to true when the "Published Jobs" card is clicked
    setShowfeaturedFreelancer(false);
    setshowAdd(false);
    setActiveCard("all");
  };
  const navigateTofeaturedFreelancer = () => {
    // history.push("/admin/Draft-Jobs"); 
    setShowall(false);
    setShowfeaturedFreelancer(true);
    setshowAdd(false);
    setActiveCard("featuredfreelancer");

  };
  const navigateToAdd = () => {
    setShowall(false);
    setShowfeaturedFreelancer(false);
    setshowAdd(true);
    setActiveCard("all");
  };
  const handleBackArrowClick = () => {
    setShowall(true); // Reset showall to true when back arrow is clicked
    setshowAdd(false);
    setActiveCard("all");
  };
  const handleExpModel = async () => {
    setshowModel(true);
    document.body.classList.add("modal-open");
  };
  const handleAddData = async (data) => {
    // Use the spread operator to create a new array with the existing items and the new data
    setUpdateFreelancer([...updateFreelancer, data.data]);

    // Rest of your code
    setshowModel(false);
    document.body.classList.remove("modal-open");

  };

  const CloseModel = () => {
    setshowModel(false);
    document.body.classList.remove("modal-open");
  };
  console.log("items", items)
  return (
    <>

      {showAdd ? (
        <>
          <div>
            <span className="container-fluid d-flex justify-content-start">
              <span className="close profile" onClick={() => handleBackArrowClick()}>
                <BsArrowLeftShort style={{ fill: "#07b274", margin: "-30px 0 0 -10px" }} />
              </span>
            </span>
            <AddFreelancer Type="Freelancer" />
          </div>

        </>
      ) : (
        <>
          <Container fluid>
            <Row>
              <Col lg="6" sm="12">
                <Card className={`card-stats ${activeCard === "all" ? "active" : ""}`} onClick={navigateToall} style={{ borderBottom: activeCard === "all" ? "4px solid #07b273" : "" }}>
                  <Card.Body>
                    <Row>
                      <Col xs="4">
                        <div className="icon-big text-center icon-warning">
                          <i className="nc-icon nc-chart text-warning"></i>
                        </div>
                      </Col>
                      <Col sm="7">
                        <div className="numbers">
                          <p className="card-category">All Freelancers</p>
                          <Card.Title as="h3">{items?.freelancer}</Card.Title>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>

              <Col lg="6" sm="12">
                <Card className={`card-stats ${activeCard === "featuredfreelancer" ? "active" : ""}`} onClick={navigateTofeaturedFreelancer} style={{ borderBottom: activeCard === "featuredfreelancer" ? "4px solid #07b273" : "" }}>
                  <Card.Body>
                    <Row>
                      <Col xs="4">
                        <div className="icon-big text-center icon-warning">
                          <i className="nc-icon nc-chart text-warning"></i>
                        </div>
                      </Col>
                      <Col sm="7">
                        <div className="numbers">
                          <p className="card-category">Featured Freelancers</p>
                          <Card.Title as="h3">{items?.featuredfreelancer}</Card.Title>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>

          <span className="container-fluid d-flex justify-content-end">
            <button
              className="btn mb-1 btn-lg mr-3"
              style={{ cursor: "pointer" }}
              onClick={() => handleExpModel()}
            >
              Import Freelancers
            </button>
            <button
              className="btn mb-1 btn-lg mr-3"
              style={{ cursor: "pointer" }}
              onClick={navigateToAdd}
            >
              Add Freelancer
            </button>
          </span>

          <Container fluid >
            {showall && <AllFreelancer updateFreelancer={updateFreelancer} handlecount={handlecount} />}
            {showfeaturedFreelancer && <FeaturedFreelancerr />}
          </Container>
        </>
      )}
      <div id="myModal"
        className={showmodel ? "model-open" : "model"}
        style={{ overflow: "auto" }}
      >
        <div className="modal-content" style={{ color: "black" }}>
          <div className="close" onClick={CloseModel} style={{ display: 'inline-block', alignSelf: 'flex-end', paddingLeft: '5px' }}>
            &times;
          </div>
          <div><UploadCSVfile handleAddData={handleAddData} /></div>
        </div>
      </div>
    </>
  );
}

export default Freelancer;
